import { render, staticRenderFns } from "./CreateMilestoneAward.vue?vue&type=template&id=b9d73890&scoped=true&"
import script from "./CreateMilestoneAward.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateMilestoneAward.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateMilestoneAward.vue?vue&type=style&index=0&id=b9d73890&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d73890",
  null
  
)

export default component.exports